<div class="container-fluid mt-2">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <button pButton pTooltip="Novo Registro" icon="pi pi-plus" class="p-button-sm p-button-success mr-2 mb-2 mt-2"
        (click)="insertDados()">
      </button>
      <button pButton pTooltip="Excluir Registro" icon="pi pi-trash" [disabled]="selectedDados.length == 0"
        class="p-button-sm p-button-danger mr-2 mb-2 mt-2" (click)="removerRegistros()">
      </button>
      <button pButton pTooltip="Atualizar Registros" icon="pi pi-refresh" (click)="recarregaDados()"
        class="p-button-sm p-button-square mb-2 mt-2">
      </button>
    </div>
    <div class="p-toolbar-group-right">
      <button pButton pTooltip="Definir Filtros" icon="pi pi-filter" (click)="showFilters()"
        class="p-button-sm p-button-secondary ml-2 mb-2 mt-2">
      </button>
      <button pButton pTooltip="Exportar Excel" icon="pi pi-file-excel" (click)="exportExcel()"
        class="p-button-sm p-button-outlined p-button-secondary ml-2 mb-2 mt-2">
      </button>
    </div>
  </p-toolbar>

  <p-table #dt [columns]="selectedColumns" [columns]="cols" [value]="dados" [rowHover]="true" [rows]="rows"
    [showCurrentPageReport]="true" [loading]="loading"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
    [autoLayout]="true" selectionMode="multiple" [(selection)]="selectedDados" id="excel-table">
    <ng-template #message pTemplate="emptymessage" let-columns>
      <tr *ngIf="dados?.length != 0">
        <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
          style="padding: 20px;">
          <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          style="width: 3rem;background: black;background-color: #212529;color: white;border-color: rgb(105, 105, 105);">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [class]="col.field === 'edit' ? 'text-center' : 'text-left'"
          style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
          [ngStyle]="{'width': col.width}">
          {{col.header}}
          <p-sortIcon [field]="col.field" class="p-sortable-colum"
            *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
          </p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-dados let-columns="columns">
      <tr>
        <td>
          <p-tableCheckbox [value]="dados"></p-tableCheckbox>
        </td>
        <td *ngFor="let col of columns">
          {{dados[col.field]}}
          <div style="display: flex;">
            <button pButton pRipple icon="pi pi-file" class="p-button-rounded p-button-secondary p-btn-sm p-mr-1"
              (click)="editDados(dados, 0)" pTooltip="Visualizar" *ngIf="col.field === 'edit'">
            </button>
            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-info p-btn-sm p-mr-1"
              (click)="editDados(dados, 2)" pTooltip="Editar" *ngIf="col.field === 'edit'">
            </button>
            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-btn-sm p-mr-1"
              (click)="removerRegistro(dados)" pTooltip="Excluir" *ngIf="col.field === 'edit'">
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-paginator *ngIf="totalRegistros > 10" [rows]="filtrosNew.quantidadeRegistrosPorPagina" [(first)]="first"
    [totalRecords]="totalRegistros" [rowsPerPageOptions]="[10,20,30,50,100]" (onPageChange)="onPageChange($event)"
    [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registro(s)">
  </p-paginator>
  <div class="card" *ngIf="dados?.length === 0">
    <div class="card-body bg-no-records p-shadow-3">
      <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
    </div>
  </div>

</div>

<app-regional-parametro-cadastro [cadastroTitulo]="cadastroTitulo" [exibeCadastro]="exibeCadastro" [cadastro]="cadastro"
  [state]="state" (recarregarDados)="retornaRecarregaDados($event)"
  (fecharModalCadastro)="retornaFecharModalCadastro($event)">
</app-regional-parametro-cadastro>

<app-regional-parametro-filtro [exibeFiltros]="exibeFiltros" [filtros]="filtrosNew"
  (fecharModalFiltros)="retornaFecharModalFiltros($event)" (aplicarFiltros)="retornaAplicarFiltros($event)">

</app-regional-parametro-filtro>

<p-confirmDialog key="regional-parametro" [style]="{width: '450px'}"></p-confirmDialog>
<p-toast key="regional-parametro" position="bottom-right"></p-toast>
